// Features/Accessories-Fold/mod.ts
var Selector_Content = `.Accessories-Fold-Content`;
var Selector_Product = `.Accessories-Product`;

class Fold extends HTMLElement {
  html_content;
  products;
  constructor() {
    super();
    this.html_content = this.querySelector(Selector_Content);
    const elements = this.querySelectorAll(Selector_Product);
    this.products = Array.from(elements);
    this.updateHeight();
    this.addEventListener("Fold:Select", (event) => {
      const { selected } = event.detail;
      this.dataset.isOpen = String(selected);
      this.updateHeight();
      const onTransitioned = () => {
        this.html_content.removeEventListener("transitionend", onTransitioned);
        this.scrollIntoView({
          behavior: "auto",
          block: "start"
        });
      };
      if (selected)
        this.html_content.addEventListener("transitionend", onTransitioned);
    });
  }
  updateHeight() {
    const content = this.html_content;
    const height = content.scrollHeight;
    if (height < 1)
      return;
    content.style.setProperty("---Height", `${height + 20}px`);
  }
  updateSelection() {
    const selected = this.products.find((product) => product.dataset.isSelected === "true");
    this.dataset.isAnySelected = String(!!selected);
  }
  get selectedProducts() {
    return this.products.filter((product) => product.dataset.isSelected === "true");
  }
}
customElements.define("accessories-fold", Fold);
export {
  Fold as AccessoriesFold
};
